import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ProductsIcon,
  CategoriesIcon,
  PromotionsIcon,
  ShipmentsIcon,
  WarehouseIcon,
  JournalIcon,
  AnalyticsIcon,
  DebtsIcon,
  PaymentsIcon,
} from './product_item_components/icons';
// import { PeriodType, getNextPeriodId, PeriodLabel } from '../types/period.type';

function DashboardActionButtons({ selectedBranchId, periodId, onPeriodChange }) {
  const navigate = useNavigate();
  const [showAll, setShowAll] = React.useState(false);
  // const currentLabel = PeriodLabel[periodId] ?? PeriodLabel[PeriodType.TODAY];

  // const handlePeriodClick = () => {
  //   const next = getNextPeriodId(periodId);
  //   onPeriodChange(next);
  // };

  const handleOrdersClick = () => {
    if (selectedBranchId) {
      navigate(`/branch/${selectedBranchId}/orders`);
    }
  };

  const handleProductsClick = () => {
    navigate(`/branch/${selectedBranchId || 'store'}/products`);
  };

  const handlePromotionsClick = () => {
    navigate('/promotions');
  };

  const handleCategoriesClick = () => {
    navigate('/categories');
  };

  const handleReplenishClick = () => {
    if (!selectedBranchId) return;
    navigate(`/branch/${selectedBranchId}/replenish`);
  };

  const handleShipmentsClick = () => {
    if (!selectedBranchId) return;
    navigate(`/branch/${selectedBranchId}/shipments`);
  };

  const handleDebtsClick = () => {
    if (!selectedBranchId) return;
    navigate(`/branch/${selectedBranchId}/debts`);
  };

  const handlePaymentsClick = () => {
    if (!selectedBranchId) return;
    navigate(`/branch/${selectedBranchId}/payments`);
  };

  const handleAnalyticsClick = () => {
    navigate(`/branch/${selectedBranchId || 'store'}/analytics`);
  };

  return (
    <div className="main-page-ordersButtonWrap">
      <div className="main-page-actionButtonsWrap">
        {/* <button
          type="button"
          className="main-page-ordersButton main-page-periodButton"
          onClick={handlePeriodClick}
          aria-label={`Период: ${currentLabel}. Нажмите для смены.`}
        >
          {currentLabel}
        </button> */}
        <button
          type="button"
          className="main-page-ordersButton main-page-ordersButton--products"
          onClick={handleProductsClick}
        >
          <ProductsIcon className="main-page-actionButtonIcon" />
          Продукты
        </button>
        <button
          type="button"
          className="main-page-ordersButton main-page-ordersButton--categories"
          onClick={handleCategoriesClick}
        >
          <CategoriesIcon className="main-page-actionButtonIcon" />
          Категории
        </button>
        {showAll ? (
          <button
            type="button"
            className="main-page-ordersButton main-page-ordersButton--promotions"
            onClick={handlePromotionsClick}
          >
            <PromotionsIcon className="main-page-actionButtonIcon" />
            Акции
          </button>
        ) : null}
        {selectedBranchId ? (
          <button
            type="button"
            className="main-page-ordersButton main-page-ordersButton--warehouse"
            onClick={handleReplenishClick}
          >
            <WarehouseIcon className="main-page-actionButtonIcon" />
            Склад
          </button>
        ) : null}
        {showAll && selectedBranchId ? (
          <button
            type="button"
            className="main-page-ordersButton main-page-ordersButton--shipments"
            onClick={handleShipmentsClick}
          >
            <ShipmentsIcon className="main-page-actionButtonIcon" />
            Доставка
          </button>
        ) : null}
        {showAll && selectedBranchId ? (
          <button
            type="button"
            className="main-page-ordersButton main-page-ordersButton--debts"
            onClick={handleDebtsClick}
          >
            <DebtsIcon className="main-page-actionButtonIcon" />
            Долги
          </button>
        ) : null}
        {showAll && selectedBranchId ? (
          <button
            type="button"
            className="main-page-ordersButton main-page-ordersButton--payments"
            onClick={handlePaymentsClick}
          >
            <PaymentsIcon className="main-page-actionButtonIcon" />
            Оплаты
          </button>
        ) : null}
        <button
          type="button"
          className="main-page-ordersButton main-page-ordersButton--analytics"
          onClick={handleAnalyticsClick}
        >
          <AnalyticsIcon className="main-page-actionButtonIcon" />
          Аналитика
        </button>
        {selectedBranchId ? (
          <button
            type="button"
            className="main-page-ordersButton main-page-ordersButton--journal"
            onClick={handleOrdersClick}
          >
            <JournalIcon className="main-page-actionButtonIcon" />
            Журнал
          </button>
        ) : null}
      </div>
      {showAll ? null : (
        <button
          type="button"
          className="main-page-moreActionsButton"
          onClick={() => setShowAll(true)}
          aria-expanded="false"
        >
          <span>Ещё</span>
        </button>
      )}
    </div>
  );
}

export default DashboardActionButtons;
